<template>
    <div class="modal-backdrop">
        <div class="modal-content">
            <div class="wrapper w-100">
                <div class="flex-column align-center confirm-loading w-100 max-w-540">
                    <div v-if="isLoaded" class="flex-column align-center">
                        <v-img src="https://static.toss.im/lotties/loading-spot-apng.png" width="120" height="120" />
                        <h2 class="title text-center">로그인 처리 중</h2>
                        <h4 class="text-center description">조금만 기다려주세요.</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { authApi } from '@/api/api';
    import { mapActions } from 'vuex';

    export default {
        props: {
            provider: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                code: null,
                state: null,
                isLoaded: false,
                isMember: false,
                providers: {
                    kakao: "카카오",
                    naver: "네이버",
                    // google: "구글",
                },
            }
        },
        methods: {
            ...mapActions('auth', ['login']),
            parseQueryParams() {
                const urlParams = new URLSearchParams(window.location.search);

                this.code = urlParams.get('code');
                this.state = urlParams.get('state') ? urlParams.get('state') : null;
            },
            removeQueryParams() {
                if (this.$route.fullPath !== this.$route.path) {
                    this.$router.replace(this.$route.path);
                }
            },
            async requestLogin() {
                const params = {
                    state: this.state,
                    auth_code: this.code,
                    provider: this.provider,
                };

                try {
                    const response = await authApi.socialLogin(params);

                    if (response && response.status === 200) {
                        this.login({ accessToken: response.data });
                        this.$router.push({ path: '/dashboard' });
                    } 
                } catch (error) {
                    if (error.response.status === 400 && error.response.data.code === "member_not_found") {
                        this.notifyVue('top', 'center', "가입하지 않은 회원입니다.");
                        this.$router.push({ path: '/login' });
                    } else if (error.response.status === 400 && error.response.data.code === "different_provider") {
                        const message =error.response.data.message;
                        this.notifyVue('top', 'center', `${message}로 가입한 계정입니다.`);
                        this.$router.push({ path: '/login' });
                    } else if (error.response.status === 400 && error.response.data.code === "sns_registered") {
                        const message =error.response.data.message;
                        this.notifyVue('top', 'center', `${message}로 가입한 계정입니다.`);
                        this.$router.push({ path: '/login' });
                    } else if (error.response.status === 400 && error.response.data.code === "invalid_password") {
                        this.notifyVue('top', 'center', "잘못된 비밀번호입니다.");
                        this.$router.push({ path: '/login' });
                    } else {
                        this.notifyVue('top', 'center', "가입하지 않은 회원입니다.");
                        this.$router.push({ path: '/login' });
                    }
                }
            },
            notifyVue(verticalAlign, horizontalAlign, alertMessage, alert_type) {
                this.$notify({
                    timeout: 8000,
                    message: alertMessage,
                    icon: "priority_high",
                    type: alert_type || "danger",
                    horizontalAlign,
                    verticalAlign,
                });
            },
        },
        async mounted() {
            await this.parseQueryParams();
            this.isLoaded = true;
            await this.removeQueryParams();
            this.requestLogin();
        },
    };
</script>

<style lang="scss" scoped>

    /* ****************** layout ****************** */
    .w-100 {
        width: 100%;
    }

    .wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 24px;
        overflow: auto;
    }

    .max-w-540 {
        max-width: 540px;
    }

    .text-center {
        text-align: center;
    }

    .flex-column {
        display: flex;
        flex-direction: column;
    }

    .align-center {
        align-items: center;
    }

    .confirm-loading {
        margin-top: 72px;
        height: 400px;
        justify-content: space-between;
    }

    /* ****************** font ****************** */

    .title {
        margin-top: 32px;
        margin-bottom: 0;
        color: #191f28;
        font-weight: bold;
        font-size: 24px;
    }

    .description {
        margin-top: 8px;
        color: #4e5968;
        font-size: 17px;
        font-weight: 500;
    }

    .color-grey {
        color: #b0b8c1;
    }

    /* ****************** modal ****************** */

    .modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999;
    }

    .modal-content {
        background-color: white;
        border-radius: 8px;
        min-width: 550px;
        max-width: 600px;
        min-height: 30%;
        max-height: 40%;
        overflow-y: hidden;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }
</style>